import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import VueRouter from 'vue-router'
import Vant from 'vant';
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'vant/lib/index.css';
import 'swiper/css/swiper.css'
import 'vant/lib/icon/local.css'
import routes from '@/router/index'
import './utils/rem.js'
import './assets/fonts/font.css'
import 'animate.css';
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '5fac63383fb610fe8a4f5cc6a1b78742', // Your AMap key
  plugin: ['AMap.Geocoder', 'AMap.Marker'], // Plugins you need
  v: '2.0' // AMap version
});
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import {getFileAccessHttpUrl} from'./utils/compUtils.js'
import { URLS } from './config/domains'

// 导入全局渐隐指令
import fadeInDirective from './directives/fadeIn'

// 注册全局指令
Vue.directive('fade-in', fadeInDirective)

// 全局跳转方法
Vue.prototype.$openNewTab = function(urlKey) {
  const url = URLS[urlKey];
  if (url) {
    window.open(url, '_blank');
  } else {
    console.warn(`URL key "${urlKey}" not found in URLS configuration`);
  }
}

Vue.prototype.$navigateTo = function(urlKey) {
  const url = URLS[urlKey];
  if (url) {
    window.location.href = url;
  } else {
    console.warn(`URL key "${urlKey}" not found in URLS configuration`);
  }
}

Vue.config.productionTip = false
Vue.prototype.$getFileAccessHttpUrl = getFileAccessHttpUrl
Vue.use(VueRouter);
Vue.use(Vant);
Vue.use(Antd)
const router = new VueRouter({routes});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
